<template>
  <div id="cardFeeMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>月车</el-breadcrumb-item>
          <el-breadcrumb-item>月车管理</el-breadcrumb-item>
          <el-breadcrumb-item>月卡续费管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             class="pageSearch">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户名称::">
            <el-select v-model="pageSearch.fCustID"
                       filterable
                       clearable
                       placeholder="请选择客户"
                       @change="loadOptions">
              <el-option v-for="item in custList"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分组名称::">
            <el-select v-model="pageSearch.fGroupID"
                       clearable
                       placeholder="请选择分组"
                       filterable>
              <el-option v-for="item in grpList"
                         :key="item.fGroupID"
                         :label="item.fGroupName"
                         :value="item.fGroupID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字::">
            <el-input placeholder="请输入卡号/车牌/用户姓名/电话/单位"
                      v-model="pageSearch.searchKeyWord">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       size="small"
                       @click="init">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  highlight-current-row
                  @current-change="handleRowChange($event,false,true)"
                  :height="tableHeight"
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column type="index"
                           width="50"
                           label="序号"
                           :index="indexMethod">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="custName"
                           width="160"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fCardNo"
                           width="80"
                           label="卡号">
          </el-table-column>
          <el-table-column prop="fGroupName"
                           width="80"
                           label="分组名称">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="用户姓名">
          </el-table-column>
          <el-table-column prop="fPlateList"
                           width="150"
                           label="车牌号码">
          </el-table-column>
          <el-table-column prop="fPlaceNums"
                           width="80"
                           align="right"
                           label="车位数量">
          </el-table-column>
          <el-table-column prop="fCardTypeName"
                           width="80"
                           label="月卡类型">
          </el-table-column>
          <el-table-column prop="fStartTime"
                           width="180"
                           label="起始时间">
          </el-table-column>
          <el-table-column prop="fEndTime"
                           width="180"
                           label="结束时间">
          </el-table-column>
          <el-table-column prop="fCommRateName"
                           width="90"
                           label="普通日费率">
          </el-table-column>
          <el-table-column prop="fHoliRateName"
                           width="90"
                           label="节假日费率">
          </el-table-column>
          <el-table-column prop="fRemark"
                           label="备注">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="80">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="warning"
                         @click="handleEdit(scope.$index, scope.row)"
                         v-if="is_edit">续费</el-button>
              <span v-if="!is_edit">-</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-tabs type="card"
               v-model="activeName">
        <el-tab-pane label="缴费记录【待同步】"
                     name="first">
          <el-table :data="synFeeRecordList"
                    border
                    highlight-current-row
                    style="width: 100%"
                    height="350">
            <el-table-column type="index"
                             width="50"
                             label="序号">
            </el-table-column>
            <el-table-column prop="OpLastTime"
                             width="150"
                             label="续费时间">
            </el-table-column>
            <el-table-column prop="fCustName"
                             label="客户">
            </el-table-column>
            <el-table-column prop="fGroupName"
                             label="月卡分组">
            </el-table-column>
            <el-table-column prop="CardTypeName"
                             label="月卡类型">
            </el-table-column>
            <el-table-column prop="custName"
                             label="用户姓名">
            </el-table-column>
            <el-table-column prop="fPlateList"
                             label="车牌">
            </el-table-column>
            <el-table-column prop="BatStartTime"
                             label="续费起始时间">
            </el-table-column>
            <el-table-column prop="BatEndTime"
                             label="续费结束时间">
            </el-table-column>
            <el-table-column prop="fPayAmount"
                             align="right"
                             label="金额">
            </el-table-column>
            <el-table-column prop="nHours"
                             align="right"
                             label="时间（小时）">
            </el-table-column>
            <el-table-column prop="fRemark"
                             label="备注">
            </el-table-column>
            <el-table-column fixed="right"
                             align="center"
                             width="230px"
                             label="操作">
              <template slot-scope="scope">
                <el-button size="mini"
                           type="danger"
                           v-if="is_edit"
                           @click="deletePay(scope.$index, scope.row)">删除</el-button>
                <el-button size="mini"
                           type="info"
                           v-if="is_syn"
                           @click="synCardPay(scope.$index, scope.row)">下发</el-button>
                <el-button size="mini"
                           type="success"
                           @click="viewCard(scope.$index, scope.row)"
                           v-if="is_syn">查看</el-button>
                <span v-if="!is_edit&&!is_syn">-</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="缴费记录"
                     name="second">
          <el-table :data="feeRecordList"
                    border
                    highlight-current-row
                    style="width: 100%"
                    height="350">
            <el-table-column type="index"
                             width="50"
                             label="序号">
            </el-table-column>
            <el-table-column prop="OpLastTime"
                             width="150"
                             label="续费时间">
            </el-table-column>
            <el-table-column prop="fCustName"
                             label="客户">
            </el-table-column>
            <el-table-column prop="fGroupName"
                             label="月卡分组">
            </el-table-column>
            <el-table-column prop="CardTypeName"
                             label="月卡类型">
            </el-table-column>
            <el-table-column prop="custName"
                             label="用户姓名">
            </el-table-column>
            <el-table-column prop="fPlateList"
                             label="车牌">
            </el-table-column>
            <el-table-column prop="BatStartTime"
                             label="续费起始时间">
            </el-table-column>
            <el-table-column prop="BatEndTime"
                             label="续费结束时间">
            </el-table-column>
            <el-table-column prop="fPayAmount"
                             align="right"
                             label="金额">
            </el-table-column>
            <el-table-column prop="nHours"
                             align="right"
                             label="时间（小时）">
            </el-table-column>
            <el-table-column prop="fRemark"
                             label="备注">
            </el-table-column>
            <el-table-column fixed="right"
                             align="center"
                             width="230px"
                             label="操作">
              <template slot-scope="scope">
                <el-button size="mini"
                           type="danger"
                           v-if="is_del"
                           @click="copyRecharge(scope.$index, scope.row)">删除</el-button>
                <el-button size="mini"
                           type="success"
                           v-if="is_set"
                           @click="editRecharge(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini"
                           type="success"
                           @click="viewCard(scope.$index, scope.row)"
                           v-if="is_syn">查看</el-button>
                <span v-if="!is_edit&&!is_set&&!is_syn">-</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-dialog :title="dialogTitle"
               top="7vh"
               width="40%"
               v-dialogDrag
               :visible.sync="dialogFormVisible">
      <el-form :model="cardPay"
               :rules="rules"
               ref="ruleForm"
               label-width="100px">
        <el-row height="10px"></el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="月卡分组"
                          prop="fGroupName">
              <el-input v-model="cardPay.fGroupName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="卡号"
                          prop="fCardNo">
              <el-input v-model="cardPay.fCardNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户姓名"
                          prop="fCustName">
              <el-input v-model="cardPay.fCustName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="绑定车牌"
                          prop="fPlateList">
              <el-input v-model="cardPay.fPlateList"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="月卡类型"
                          prop="fCardTypeName">
              <el-input v-model="cardPay.fCardTypeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="金额(元)"
                          prop="fPayAmount">
              <el-input v-model="cardPay.fPayAmount"
                        placeholder="请填写金额(元)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="cardPay.fCardTypeID==='40'"
                          label="购买时间(小时)"
                          prop="fPaySecs">
              <el-input v-model="cardPay.fPaySecs"></el-input>
            </el-form-item>
            <el-form-item v-else-if="cardPay.fCardTypeID==='50'"
                          label="购买次数(次)"
                          prop="fPayCount">
              <el-input v-model="cardPay.fPayCount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="起始时间"
                          prop="fBatStartTime">
              <el-date-picker v-model="cardPay.fBatStartTime"
                              style="width:100%"
                              type="datetime"
                              placeholder="选择起始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间"
                          prop="fBatEndTime">
              <el-date-picker v-model="cardPay.fBatEndTime"
                              type="datetime"
                              style="width:100%"
                              placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注"
                          prop="fRemark">
              <el-input v-model="cardPay.fRemark"
                        type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :loading="save_loading"
                   @click="submitForm('ruleForm')">{{save_msg}}</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <cardView ref="child"
              cardActiveName="cardList"
              :choiceCusts="custList"></cardView>
  </div>
</template>
<script>
import cardView from '../../components/cardView'
import * as api from '../../api/card'
import { mapActions } from 'vuex'
export default {
  components: { cardView },
  data () {
    var validateInt = (rule, value, callback) => {
      if ((value || '').trim().length > 0) {
        if (!/^[0-9]+$/.test(value)) {
          callback(new Error('请填写正整数'))
        }
      }
      callback()
    }
    return {
      is_edit: false,
      is_syn: false,
      is_del: false,
      is_set: false,
      activeName: 'first',
      tableHeight: 0,
      dialogFormVisible: false,
      loading: false,
      save_loading: false,
      save_msg: '保存',
      dialogTitle: '',
      pageData: [],
      groupList: [],
      custList: [],
      grpList: [],
      feeRecordList: [],
      synFeeRecordList: [],
      pageCount: 0,
      pageSearch: {
        pageNo: 1,
        pageSize: 20,
        fCustID: '',
        fGroupID: '',
        searchKeyWord: '',
        cardActiveName: 'cardList'
      },
      cardPay: {
        fBigRowID: '',
        fGroupName: '',
        fCardID: '',
        fCustID: '',
        fCardNo: '',
        fCustName: '',
        fPlateList: '',
        fCardTypeName: '',
        fPayAmount: '',
        fCardTypeID: '',
        fPaySecs: '',
        fPayCount: '',
        fBatStartTime: '',
        fBatEndTime: '',
        fRemark: '',
        fCustTypeID: ''
      },
      rules: {
        fPayAmount: [
          { required: true, message: '请填写金额', trigger: 'blur' },
          { validator: validateInt, trigger: 'blur' }
        ],
        fPaySecs: [
          { required: true, message: '请填写购买时间(小时)', trigger: 'blur' },
          { validator: validateInt, trigger: 'blur' }
        ],
        fPayCount: [
          { required: true, message: '请填写购买次数(次)', trigger: 'blur' },
          { validator: validateInt, trigger: 'blur' }
        ],
        fBatStartTime: [
          { required: true, message: '请选择起始时间', trigger: 'change' }
        ],
        fBatEndTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    ...mapActions([
      'getCardByQuery', 'getCardGroupByCustId', 'getCustByGroup', 'getRechargeList', 'saveRecharge', 'synRecharge', 'deleteRecharge', 'getCurrentUserPers',
      'loadCardOtherList', 'getRechargeList', 'getCarPresnetList'
    ]),
    viewCard (index, row) {
      this.$refs.child.viewCard(row, true)
    },
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageNo = index
      } else {
        this.pageSearch.pageNo = 1
      }
      this.loading = true
      this.feeRecordList = []
      // this.synFeeRecordList = []
      this.handleRowChange({ fCustID: this.pageSearch.fCustID }, true, false)
      this.getCardByQuery(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.rows || []
            this.pageCount = data.Data.total
            if (this.pageData.length > 0) {
              this.handleRowChange(this.pageData[0], false, true)
            }
          } else {
            this.$message.error('提示:' + data.Msg)
          }
        }
      })
    },
    changeGrp (obj) {
      var group = this.groupList.find(r => r.fGrpID === obj)
      if (group) {
        if (!(this.cust.fCustNo || '').trim().length > 0) {
          this.cust.fCustNo = group.fGrpNo
        }
        this.fGrpNo = group.fGrpNo
        this.$refs['ruleForm'].validateField('fCustNo', (errorMsg) => {
        })
      }
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageNo - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageNo)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleRowChange (newRow, isLoadsyn, isLoad) {
      if (newRow) {
        if (isLoad) {
          this.feeRecordList = []
          this.getRechargeList({ fCardID: newRow.fCardID, fCustID: newRow.fCustID, isSyn: false }).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.feeRecordList = data.Data
              } else {
                this.$message.error('提示：加载月卡续费列表信息失败')
              }
            }
          })
        }
        if (isLoadsyn) {
          this.synFeeRecordList = []
          // { fCardID: newRow.fCardID, fCustID: newRow.fCustID, isSyn: true }
          this.getRechargeList({ fCardID: 0, fCustID: newRow && newRow.fCustID > 0 ? newRow.fCustID : 0, isSyn: true }).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.synFeeRecordList = data.Data
              } else {
                this.$message.error('提示：加载月卡续费列表信息失败')
              }
            }
          })
        }
      }
    },
    deletePay (index, row) {
      this.$confirm('此操作将永久删除该续费记录, 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.deleteRecharge({ fBigRowID: row.fBigRowID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.handleRowChange(row, true, false)
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    editRecharge (index, row) {
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].clearValidate()
      }
      this.dialogTitle = row.fCardNo + '-修改续费'
      if ((this.custName || '').trim().length > 0) {
        this.dialogTitle = '【' + this.custName + '】' + row.fCardNo + '-修改续费'
      }
      var fBatStartTime = new Date(row.BatStartTime)
      var fBatEndTime = new Date(row.BatEndTime)
      this.cardPay = {
        fCardID: row.fCardID,
        fCustID: row.fCustID,
        fBigRowID: row.cardfBigRowID,
        recfBigRowID: row.fBigRowID,
        fCardNo: row.fCardNo,
        fCustName: row.fCustName,
        fPlateList: row.fPlateList,
        fCardTypeName: row.CardTypeName,
        fCardTypeID: row.fCardTypeID,
        fGroupName: row.fGroupName,
        fPayAmount: '',
        fPaySecs: 0,
        fBatStartTime: this.$dateFormat(fBatStartTime, 'yyyy-MM-dd hh:mm:ss'),
        fBatEndTime: this.$dateFormat(fBatEndTime, 'yyyy-MM-dd hh:mm:ss'),
        fRemark: '',
        fCustTypeID: 0,
        fIsEdit: 1
      }
      this.dialogFormVisible = true
    },
    copyRecharge (index, row) {
      this.$confirm('此操作将永久删除该续费记录, 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.copyRecharge({ fBigRowID: row.fBigRowID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: '删除到待同步成功!'
              })
              this.handleRowChange(row, true, false)
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    handleEdit (index, row) {
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].clearValidate()
      }
      this.dialogTitle = row.fCardNo + '-续费'
      if ((this.custName || '').trim().length > 0) {
        this.dialogTitle = '【' + this.custName + '】' + row.fCardNo + '-续费'
      }
      var fBatStartTime = new Date(row.ncdEndTime)
      var fBatEndTime = new Date(row.fEndTime)
      fBatEndTime = new Date(fBatEndTime.setMonth(fBatEndTime.getMonth() + 1))
      this.cardPay = {
        fCardID: row.fCardID,
        fCustID: row.fCustID,
        fBigRowID: row.fBigRowID,
        recfBigRowID: 0,
        fCardNo: row.fCardNo,
        fCustName: row.fCustName,
        fPlateList: row.fPlateList,
        fCardTypeName: row.fCardTypeName,
        fCardTypeID: row.fCardTypeID,
        fGroupName: row.fGroupName,
        fPayAmount: '',
        fPaySecs: 0,
        fBatStartTime: this.$dateFormat(fBatStartTime, 'yyyy-MM-dd hh:mm:ss'),
        fBatEndTime: this.$dateFormat(fBatEndTime, 'yyyy-MM-dd hh:mm:ss'),
        fRemark: '',
        fCustTypeID: row.fCustTypeID,
        fIsEdit: 0
      }
      this.dialogFormVisible = true
    },
    synCardPay (index, row) {
      this.$confirm('是否将该待同步的月卡【' + row.fCustName + '】-【' + row.fPlateList + '】下发到线下?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.synRecharge({ fBigRowID: row.fBigRowID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.handleRowChange({ fCustID: this.pageSearch.fCustID }, true, false)
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formDisabled) { return }
          if (this.cardPay.fBatStartTime instanceof Date) {
            this.cardPay.fBatStartTime = this.$dateFormat(this.cardPay.fBatStartTime, 'yyyy-MM-dd hh:mm:ss')
          }
          if (this.cardPay.fBatEndTime instanceof Date) {
            this.cardPay.fBatEndTime = this.$dateFormat(this.cardPay.fBatEndTime, 'yyyy-MM-dd hh:mm:ss')
          }
          this.save_loading = true
          this.save_msg = '保存中…'
          this.saveRecharge(this.cardPay).then(res => {
            this.save_loading = false
            this.save_msg = '保存'
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogFormVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.handleRowChange(this.cardPay, true, false)
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          })
        }
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 650
      clientHeight = clientHeight < 200 ? 200 : clientHeight
      obj.tableHeight = clientHeight
    },
    loadOptions (fCustID) {
      this.pageSearch.fGroupID = ''
      this.grpList = []
      this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.grpList = data.Data
          } else {
            this.$message.error('提示：加载月卡分组列表失败')
          }
        }
      })
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 33000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_syn = data.Data.data.is_syn
            this.is_del = data.Data.data.is_del
            this.is_set = data.Data.data.is_set
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.getCustByGroup().then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.custList = data.Data || []
          }
        }
      }
    })
    // this.init()
    // this.handleRowChange({}, true, false)
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
#cardFeeMain .is-disabled .el-input__inner,
#cardFeeMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#cardFeeMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#cardFeeMain .el-dialog__title {
  color: white;
}
#cardFeeMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#cardFeeMain .el-dialog__body {
  padding: 5px;
}
#cardFeeMain .warning-row {
  color: chocolate;
}
#cardFeeMain .error-row {
  color: #fb4545;
}
/* dialog弹出框样式 */
#cardFeeMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#cardFeeMain .el-dialog__title {
  color: white;
}
#cardFeeMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
/*#cardFeeMain .el-dialog__body {*/
/*padding: 30px 20px;*/
/*}*/
#cardFeeMain .is-disabled .el-input__inner,
#cardFeeMain .is-disabled .el-textarea__inner {
  color: #606266;
}
</style>
<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-form-item {
  margin-bottom: 20px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 300px;
}
.searchRowAdd {
  text-align: right;
}
.myCardLableClass .isRed {
  color: #fb4545;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.curRowInfo {
  margin-top: 10px;
}
.curRowInfo .el-row {
  margin-top: 10px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.el-upload__tip {
  margin-top: 0px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/view/card/cardFeeMain.vue